import {ReportBanners} from './index';

// Some banners are controlled by certain factors such as whether or not to show a banner
// for a certain report type and report id, or a specific tab in alert settings. That information
// must be set explicitly on each report the banner could show for
export function addAttributeToBanner(attr, value) {
  const banners: ReportBanners = document.querySelector(`mp-report-banners`);
  if (banners && !banners.isAttributeEnabled(`persistent`)) {
    banners.setAttribute(attr, value);
  }
}
